import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-carousel-stay-stuned',
  templateUrl: './carousel-stay-stuned.component.html',
  styleUrls: ['./carousel-stay-stuned.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarouselStayStunedComponent {
  @Input() public data: any[] = [];
}
